// Dependencies
import React, { useEffect, useState } from 'react';
import { Row, Col, Dropdown } from 'react-bootstrap';
import { GlobeAmericas } from "react-bootstrap-icons";
import { FormattedMessage, useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux';
import Logo from "../../assets/images/logo.png";
import { actions as actionsLang, getLang } from '../../reducers/lang';
import { getStep } from '../../reducers/Step';
import { Outlet } from 'react-router-dom';


const Layout = () => {
    const intl = useIntl();
    const distpatch = useDispatch();
    const reduxLang = useSelector(getLang);
    const page = useSelector(getStep);

    const titles = [
        { title: intl.formatMessage({ id: "step.title.one" }) },
        { title: intl.formatMessage({ id: "step.title.two" }) },
        { title: intl.formatMessage({ id: "step.title.three" }) },
        { title: intl.formatMessage({ id: "step.title.four" }) }
    ];

    const handleSelecLang = (e) => {
        e.preventDefault();
        distpatch(actionsLang.setLang(e.target.id));
    }

    const currentYear = () => {
        return new Date().getFullYear();
    }

    return (
        <>
        <header>
            <Row className="justify-content-md-center border pt-3 pb-3">
                <Col className='align-self-center text-center' sm={{span:12}} md={{span:4}} lg={{span:3}}>
                    <a href='https://famsafurniture.com/'><img src={Logo} /></a>
                </Col>
                <Col className='align-self-center text-center' sm={{span:12}} md={{span:6}} lg={{span:6}}>
                    <h1 className='famsa-text-red'><FormattedMessage id="header.title1" /></h1>
                    <h4 className='famsa-text-blue'>{(page === null) ? <FormattedMessage id='header.title2'/> : titles[page].title}</h4>
                </Col>
                <Col className='align-self-center text-center' sm={{span:12}} md={{span:2}} lg={{span:3}}>
                    <Dropdown>
                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                            <GlobeAmericas /> {reduxLang}
                        </Dropdown.Toggle>
                        <Dropdown.Menu onClick={(e) => handleSelecLang(e)}>
                            <Dropdown.Item id="en-US"><FormattedMessage id="lang.enUS" /></Dropdown.Item>
                            <Dropdown.Item id="es-MX"><FormattedMessage id="lang.esMX" /></Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </Col>
            </Row>
        </header>
        <Outlet/>
        <footer>
            <Row className="justify-content-md-center border pt-3 pb-3 famsa-bg-red">
                <Col className='text-white ms-3'>
                    Copyright © {new Date().getFullYear()} Famsa Inc. All Rights Reserved.
                </Col>
            </Row>
        </footer>
        </>
    );
}

export default Layout;